import { render, staticRenderFns } from "./SendFileToAdmin.vue?vue&type=template&id=a23b15bc&"
import script from "./SendFileToAdmin.vue?vue&type=script&lang=js&"
export * from "./SendFileToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SendFileToAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports